// extracted by mini-css-extract-plugin
export default {"label_wrapper":"FieldTitle_label_wrapper__aobky","tag_text":"FieldTitle_tag_text__l-xBG"};